import React from 'react';
import { Rule } from 'antd/lib/form';
import { PropsWithChildren } from 'react';
import { InputField } from '../InputField';
import { Form, Button, Input, Select, Space } from 'antd';

export interface IMappedProps {
    key: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
    itemStyle?: any;
    default_require_message?: string;
    require_message?: string;
    rules: Rule[];
    defaultValue?: any;
    prefixSelector?: any;
    props?: any;
    extra?: any
    inputStyle?: any;
    name?: string | [string];
    fieldKey?: string | any;
    onDataChanged?: (fieldKey: string[]|string, value: any) => void;
    hidden?:boolean;
}

export function mappedProps(fProps: any) {
    const key = fProps.key;
    // console.log("BASIC PROPS: ", fProps)
    const defaultRequireMessage =
        'Please input ' + fProps ? (fProps.label ? fProps.label : key) : key;
    const outputProps: IMappedProps = {
        key: key,
        fieldKey: fProps.fieldKey ? fProps.fieldKey : key,
        label: fProps ? (fProps.label ? fProps.label : key) : key,
        placeholder: fProps
            ? fProps.placeholder
                ? fProps.placeholder
                : key
            : key,
        required: fProps ? (fProps.required ? fProps.required : false) : false,
        itemStyle: fProps ? (fProps.itemStyle ? fProps.itemStyle : ((fProps.extra && fProps.extra.itemStyle) ? fProps.extra.itemStyle : {})) : {},
        inputStyle: fProps ? (fProps.inputStyle ? fProps.inputStyle : ((fProps.extra && fProps.extra.inputStyle) ? fProps.extra.inputStyle : {})) : {},
        default_require_message: defaultRequireMessage,
        require_message: fProps.extra
            ? fProps.extra.require_message
                ? fProps.extra.require_message
                : defaultRequireMessage
            : defaultRequireMessage,
        rules: (fProps && fProps.extra) ? (fProps.extra.rules ? fProps.extra.rules : []) : [],
        defaultValue: fProps.value?fProps.value:(fProps.defaultValue?fProps.defaultValue:""),
        props: (fProps && fProps.extra) ? (fProps.extra.props ? fProps.extra.props : {}) : {},
        extra: (fProps && fProps.extra) ? { ...fProps.extra } : {},
        name:fProps.name,
        onDataChanged: fProps.onDataChanged,
        hidden:fProps.isHidden
    };
    if (fProps && fProps.defaultValue)
        outputProps.defaultValue = fProps.defaultValue;

    return outputProps;
}


export interface IFormItemProps {
    item: InputField,
    isSubItem?: boolean
}


export default function FormItem(props: PropsWithChildren<IFormItemProps>) {
    const mapProps = mappedProps(props.item);
    const itemName = mapProps.name ? (Array.isArray(mapProps.name) ? [...mapProps.name, mapProps.key] : [mapProps.name, mapProps.key]):mapProps.key
    // console.log("ITEM NAME: =======", itemName)
    let customRules: Rule[] = [];
    if (mapProps.rules) {
        customRules = mapProps.rules;
    }

    return (
        <Form.Item
            label={(mapProps.extra && mapProps.extra.hideLabel) ? "" : mapProps.label}
            key={mapProps.key}
            hasFeedback
            fieldKey={[mapProps.fieldKey, mapProps.key]}
            labelAlign="left"
            className="tl-text-violet-14"
            colon={false}
            style={{
                lineHeight: '20px',
                fontSize: '14px',
                fontFamily: 'Inter',
                fontWeight: 'bold',
                background: 'white',
                padding: props.isSubItem ? '0px' : '8px',
                paddingLeft: props.isSubItem ? '0px' : '16px',
                paddingRight: props.isSubItem ? '0px' : '16px',
                borderRadius: '8px',
                marginBottom: props.isSubItem ? '0px' : '4px',
                ...mapProps.itemStyle
            }}
            // labelCol={{ span: 5 }}
            hidden={mapProps.hidden}
            name={itemName}
            rules={[
                {
                    required: mapProps.required,
                    message: mapProps.require_message,
                },
                ...customRules,
            ]}
            // initialValue={mapProps.defaultValue}
        >
            {props.children}
        </Form.Item>
    );
}
